import { UploadFile } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import Dropzone, { DropzoneProps } from 'react-dropzone';

interface Props extends DropzoneProps {
  /** show this image instead of the upload icon */
  imageUrl?: string;
  instructions?: string;
}
export default function StyledDropzone({ imageUrl, instructions, ...props }: Props): React.JSX.Element {
  const contentImage = useMemo(
    () => (
      <Box>
        {imageUrl !== undefined ? (
          <img src={imageUrl} alt={'Logo'} style={{ maxWidth: 340, margin: 4 }} />
        ) : (
          <UploadFile
            sx={{
              fontSize: '6em',
              color: (theme) => theme.palette.text.disabled,
              display: 'block',
              margin: '0 auto',
              p: 2,
            }}
          />
        )}
      </Box>
    ),
    [imageUrl],
  );

  const contentText = useMemo(() => {
    if (instructions === undefined) {
      return <></>;
    }

    return (
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '1.2em',
          fontWeight: 400,
          color: (theme) => theme.palette.text.disabled,
        }}
      >
        {instructions}
      </Typography>
    );
  }, [instructions]);

  return (
    <Dropzone {...props}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <Box
          component={'div'}
          {...getRootProps()}
          sx={{
            position: 'relative',
            width: '100%',
            backgroundColor: (theme) => (isDragActive ? theme.palette.action.hover : theme.palette.background.default),
            border: 'dashed 0.2rem',
            borderColor: (theme) => (isDragActive ? theme.palette.primary.main : theme.palette.text.disabled),
            borderRadius: 2,
            cursor: 'pointer',
            boxSizing: 'border-box',
            outline: 'none',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 3,
            transition: (theme) =>
              theme.transitions.create(['border-color', 'background-color'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.short,
              }),
            '&:hover': {
              backgroundColor: (theme) => theme.palette.action.hover,
              borderColor: (theme) => theme.palette.primary.main,
            },
          }}
        >
          <input {...getInputProps()} />
          {contentImage}
          {contentText}
        </Box>
      )}
    </Dropzone>
  );
}
